export default {"src":"/_next/static/media/userIcon.39f1519a.svg","height":18,"width":18};